import React, { useState, useEffect } from "react";
import classes from "./ManageUser.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2,Lock } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from 'sweetalert2'
import ToggleSlider from './ToggleSlider';
import { Spinner, Badge, Button, Modal, Form, Row, Col } from 'react-bootstrap';

const ManageUser = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [userPer,setUserPer] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPermisionOpenModal, setIsPermissionModalOpen] = useState(false);
    const [isNewModalOpen, setIsNewModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [NewUser, setNewUser] = useState([]);
    const [locations, setLocations] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userPermissions, setUserPermissions] = useState({}); 
    const [roleStates, setRoleStates] = useState({});
     const [roles, setRoles] = useState([]);
       const [roleLoading, setRoleLoading] = useState(false);
        const [roleCheckAll, setRoleCheckAll] = useState(false);
          const [selectAll, setSelectAll] = useState(false);

    const pageMap = {
        "/dashboard": "Dashboard",
        "/transactions": "Transactions",
        "/accounts": "Accounting",
        "/reports": "Reports",
        "/banking": "Banking",
        "/settings": "Settings",
    };

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone_no: '',
        location_id: '',  // ✅ correct field
    });
    const [editformData, setEditFormData] = useState({
        name: '',
        email: '',
        phone_no: '',
        location_id: '',  // ✅ correct field
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Fixed fetchLocations with better debugging
    const fetchLocations = async () => {
        setLoadingLocations(true);
        try {
            const response = await api.get(`/v1/location`);

            // Debug: Log the entire response to see the structure
            console.log("📍 Full API Response:", response.data);

            // Try multiple possible response structures
            let locationsData = [];
            if (response.data?.data?.data) {
                locationsData = response.data.data.data;
            } else if (response.data?.data) {
                locationsData = response.data.data;
            } else if (Array.isArray(response.data)) {
                locationsData = response.data;
            } else {
                console.warn("⚠️ Unexpected API response structure:", response.data);
                locationsData = [];
            }

            console.log("📍 Processed locations data:", locationsData);

            // Ensure it's an array and has the expected structure
            if (Array.isArray(locationsData) && locationsData.length > 0) {
                console.log("📍 First location object:", locationsData[0]);
                // Check if locations have the expected properties
                const firstLocation = locationsData[0];
                if (!firstLocation.id || (!firstLocation.name && !firstLocation.location_name && !firstLocation.title)) {
                    console.warn("⚠️ Location objects missing expected properties:", firstLocation);
                }
            }

            setLocations(locationsData);
        } catch (error) {
            console.error("❌ Error fetching locations:", error.response?.data || error.message);
            Swal.fire({
                icon: "error",
                title: "Failed to Load Locations",
                text: "Could not load location options. Please try again.",
            });
            setLocations([]);
        } finally {
            setLoadingLocations(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const selectedRoles = roles
      .filter((item) => roleStates[item.name])
      .map((item) => item.id);
 
        try {
            const payload = {
                name: formData.name,
                email: formData.email,
                phone_no: formData.phone_no,
                location_id: formData.location_id,
                role: selectedRoles[0] || null,
            };

            console.log("📤 Sending Payload:", payload);

            const body = withCompanyId(payload);
            // Use the user creation endpoint (assign_to_user expects different payload keys)
            const response = await api.post(`/v1/users/create-new`, body);

            console.log("✅ User creation response:", response.data);

            // Reset form and close modal
            setFormData({
                name: "",
                email: "",
                phone_no: "",
                location_id: "",
            });

            setIsModalOpen(false);

            Swal.fire({
                icon: "success",
                title: "User Added",
                text: response.data.message || 'User added successfully!',
                timer: 2000,
                showConfirmButton: false,
            });

            // Refresh the user list
            fetchNewUser();

        } catch (error) {
            console.error("❌ Error creating user:", error.response?.data || error.message);
            console.log("❌ Error Keys:", Object.keys(error.response?.data || {}));

            const errorMessage =
                typeof error.response?.data?.message === "object"
                    ? Object.values(error.response.data.message).flat().join("\n")
                    : error.response?.data?.message || "Something went wrong.";

            Swal.fire({
                icon: "error",
                title: "Failed to Add User",
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const selectedRoles = roles
  .filter((item) => roleStates[item.id])
  .map((item) => item.id);

        try {
           const payload = {
  user_id: userPer?.id,
  role: selectedRoles[0] || null,
};

            console.log("📤 Sending Payload:", payload);

            const body2 = withCompanyId(payload);
            const response = await api.post(`/v1/role/assign-permissions`, body2);

            console.log("✅ User creation response:", response.data);

         
           

            Swal.fire({
                icon: "success",
                title: "Permissions Updated",
                text: response.data.message || 'Permission Updated successfully!',
                timer: 2000,
                showConfirmButton: false,
            });

             setIsPermissionModalOpen(false);
            fetchNewUser();

        } catch (error) {
            console.error("❌ Error creating user:", error.response?.data || error.message);
            console.log("❌ Error Keys:", Object.keys(error.response?.data || {}));

            const errorMessage =
                typeof error.response?.data?.message === "object"
                    ? Object.values(error.response.data.message).flat().join("\n")
                    : error.response?.data?.message || "Something went wrong.";

            Swal.fire({
                icon: "error",
                title: "Failed to Update Permissions",
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };

    const fetchNewUser = async () => {
        try {
            const res = await api.get(`/v1/users/fetch-all`);

            const newUserData = res.data?.data?.data || res.data?.data || [];
            setNewUser(newUserData);
        } catch (err) {
            console.error("Error fetching user:", err?.response?.data || err.message);
            setError(err.response?.data?.message || "Failed to fetch users. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');

        if (!authToken) {
            setError("Authorization token not found.");
            navigate('/signin');
            return;
        }

        fetchNewUser();
    }, [navigate]);

    // Fetch locations when component mounts (for displaying in table) and when modal opens
    useEffect(() => {
        fetchLocations(); // Load locations on component mount for table display
    }, []);

    useEffect(() => {
        if (isModalOpen) {
            // Locations are already loaded, but fetch again if empty
            if (locations.length === 0) {
                fetchLocations();
            }
        }
    }, [isModalOpen, locations.length]);
      const handleRoleToggleChange = (itemId) => {
    setRoleStates(prevRoleStates => {
      // Only allow one role to be selected at a time
      const updatedStates = {};
      roles.forEach(role => {
        updatedStates[role.name] = role.name === itemId;
      });
      updatedStates[itemId] = !prevRoleStates[itemId];
      
      return updatedStates;
    });
  };

    const fetRoles = async () => {
         const authToken = localStorage.getItem('authToken');
    setRoleLoading(true);
    try {
        const response = await api.get(`/v1/payroll/role`);
      const data = response.data?.data;
    //   const rolessId = data.map(item => item.id);
    //   setRoleID(rolessId);
      // console.log(data);
      const initialToggleStates = Object.fromEntries(
      data.map(role => [role.name, false])
    );

      // const initialToggleStates = false; 


      setRoles(data);
      setRoleStates(initialToggleStates);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setRoles([]);
    } finally {
      setRoleLoading(false);
    }
  };

  useEffect(() => {
      fetRoles();
  },[]);
  
    const handleSelectAllChange = () => {
    const newValue = !selectAll;
    const updatedStates = {};
    // When toggling, only select the first role (single role selection)
    roles.forEach((role, index) => {
      updatedStates[role.name] = newValue && index === 0;
    });
    setRoleStates(updatedStates);
    setSelectAll(newValue);
  };
    const handleSelectEditChange = () => {
    const allSelected = Object.values(roleStates).every(Boolean);
    const newStates = {};
    // When toggling, only select the first role (single role selection)
    roles.forEach((role, index) => {
      newStates[role.id] = !allSelected && index === 0;
    });
    setRoleStates(newStates);
  };

  const permissionHandler = (user) => {
    console.log(user)
    setUserPer(user)
    setIsPermissionModalOpen(true);
    
  }

  useEffect(() => {
  if (roles.length > 0 && userPer?.permissions) {
    const userPermissionIds = userPer.permissions.map(p => p.id);
    const initialStates = roles.reduce((acc, role) => {
      acc[role.id] = userPermissionIds.includes(role.id);
      return acc;
    }, {});
    setRoleStates(initialStates);
  }
}, [roles, userPer]);

  const handleToggle = (permissionName) => {
  setRoleStates(prev => ({
    ...prev,
    [permissionName]: !prev[permissionName],
  }));
}

const handleToggleChange = (permissionName, userId) => {
  setUserPermissions(prev => {
    const current = prev[userId] || [];
    const updated = current.includes(permissionName)
      ? current.filter(p => p !== permissionName)
      : [...current, permissionName];

    return { ...prev, [userId]: updated };
  });
  setRoleStates(prev => ({
    ...prev,
    [permissionName]: !prev[permissionName],
  }));
};


const handleEditClick = (user) => {
  setEditingUser(user);

  setEditFormData({
    name: user.name || "",
    email: user.email || "",
    phone_no: user.phone_no || "",
    location_id: user.location_id || "",
  });

  // Extract just the names of permissions the user has
  const userPermissionNames = user.permissions?.map(p => p.name) || [];

  // Build toggle states: true if user has that permission
  const initialToggleStates = Object.fromEntries(
    roles.map(role => [
      role.name,
      userPermissionNames.includes(role.name)
    ])
  );

  setRoleStates(initialToggleStates);
};

    // Separate change handler for edit form
    const handleEditChange = (e) => {
        setEditFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    // Submit handler to update existing user
    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const payload = {
                user_id: editingUser?.id || editformData.id,
                name: editformData.name,
                email: editformData.email,
                phone_no: editformData.phone_no,
                location_id: editformData.location_id,
            };

            const body = withCompanyId(payload);
            const res = await api.post(`/v1/users/update-user`, body);

            Swal.fire({
                icon: "success",
                title: "User Updated",
                text: res.data?.message || "User updated successfully",
                timer: 1500,
                showConfirmButton: false,
            });

            setIsNewModalOpen(false);
            fetchNewUser();
        } catch (err) {
            console.error("❌ Error updating user:", err?.response?.data || err.message);
            const errorMessage =
                typeof err.response?.data?.message === "object"
                    ? Object.values(err.response.data.message).flat().join("\n")
                    : err.response?.data?.message || "Failed to update user.";
            Swal.fire({ icon: "error", title: "Update Failed", text: errorMessage });
        } finally {
            setSubmitting(false);
        }
    };





    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.PgeContainerDisp}>
                <div className={classes.actionsbtn_On}>
                    <button className={classes.btns_New}
                        onClick={() => navigate('/transactions/sales-invoice/sale')}>Sales Invoice</button>
                    <button className={classes.btns_New}
                        onClick={() => navigate('/inventory/purchaseOrder')}>Purchase Invoice</button>
                    <button className={`${classes.btns_New} ${classes.greens}`}
                        onClick={() => navigate('/settings/product-services')}>Product & Services</button>
                    <button className={`${classes.btns_News} ${classes.greens}`}>Manage Users</button>
                </div>
                <header className={classes.FrtHeaderOne}>
                    <h2 className={classes.FrtTitleOne}>Manage Users</h2>
                </header>

                {/* <div className={classes.entrjjyer}>
                    <div className={classes.allkadsPage}>
                        <div className={classes.thrdkadPage}>
                            <div className={classes.kadOne}>
                                <p className={classes.kdptgpt}>Total Purchase</p>
                                <p className={classes.kdptgpt1}>₦8,400,000.00</p>
                                <div className={classes.rvnueOpt}>
                                    <p className={classes.skaltxt001}>This month</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkadIs}>
                            <div className={classes.kadOne}>
                                <p className={classes.kdptgpt}>Outstanding</p>
                                <p className={classes.kdptgpt2}>₦4,950,000.00</p>
                                <div className={classes.rvnueOpt}>
                                    <p className={classes.skaltxt001}>Pending payments</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkadOn}>
                            <div className={classes.kadOne}>
                                <p className={classes.kdptgpt}>Overdue</p>
                                <p className={classes.kdptgpt3}>₦3,200,000.00</p>
                                <div className={classes.rvnueOpt}>
                                    <p className={classes.skaltxt001}>Past due dates</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkadOne}>
                            <div className={classes.kadOne}>
                                <p className={classes.kdptgpt}>This month</p>
                                <p className={classes.kdptgpt4}>15</p>
                                <div className={classes.rvnueOpt}>
                                    <p className={classes.skaltxt001}>Total invoices</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className={classes.headerforActions}>
                    <div className={classes.actionsSideRight}>
                        <div className={classes.inputWrapperTxt}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreenLrg} />
                            <input type="text" className={classes.searchLxtBar} placeholder="Search user" />
                        </div>
                    </div>
                    <button
                        className={classes.btnssBtnss}
                        onClick={() => setIsModalOpen(true)}>Add User</button>
                </div>

                <div className={classes.newUserCont}>
                    <table className={classes.newUserTable}>
                        <thead style={{ whiteSpace: "nowrap" }}>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Location</th> {/* ✅ Added */}
                                <th className={classes.actionMove}>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading
                                ? Array(5)
                                    .fill()
                                    .map((_, idx) => (
                                        <tr key={idx}>
                                            {Array(6) // <-- changed to 6 because we now include Location column
                                                .fill()
                                                .map((_, i) => (
                                                    <td key={i}>
                                                        <Skeleton height={20} style={{ marginBottom: 10 }} />
                                                    </td>
                                                ))}
                                        </tr>
                                    ))
                                : NewUser.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} style={{ textAlign: "center" }}>
                                            No User found.
                                        </td>
                                    </tr>
                                ) : (
                                    NewUser.map((user, index) => {
                                        // Find the matching location object
                                        const locationObj = locations.find(
                                            (loc) => String(loc.id) === String(user.location_id)
                                        );

                                        return (
                                            <tr key={user.id}>
                                                <td>{index + 1}</td>
                                                <td>{user.name}</td>
                                                <td>{user.email}</td>
                                                <td>{user.phone_no}</td>
                                                <td>{locationObj ? locationObj.location_address : "N/A"}</td>
                                                <td className={classes.actionsEditDelete}>
                                                    <Pen
                                                        size={16}
                                                        className={classes.editActionIcon}
                                                        onClick={() => {setIsNewModalOpen(true); handleEditClick(user)}}
                                                    />
                                                    <Trash2
                                                        size={16}
                                                        className={classes.deleteActionIcon}
                                                         onClick={() => {
                                                                setUserToDelete(user);
                                                                setIsDeleteModalOpen(true);
                                                            }}
                                                    />
                                                     <Lock
    size={16}
    className={classes.permissionActionIcon} 
    onClick={() => permissionHandler(user)}
    />
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                        </tbody>


                    </table>

                    <div className={classes.paginationContainertxt}>
                        <div className={classes.paginationControlstxt}>
                            <button>First</button>
                            <button className={classes.activation}>1</button>
                            <button>Last</button>
                            <span className={classes.pageDisplayText}>Displaying 1 - 41 of 41</span>
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        <div className={classes.modalModalHeader}>
                            <h2>Add User</h2>
                            <button
                                className={classes.closeModalBtn}
                                onClick={() => setIsModalOpen(false)}
                            >
                                &times;
                            </button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className={classes.modalModalBody}>
                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Enter Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className={classes.modalFormGroup}>
                                        <label>Phone Number</label>
                                        <input
                                            type="number"
                                            name="phone_no"
                                            placeholder="Enter Phone Number"
                                            value={formData.phone_no}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Enter Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className={classes.modalFormGroup}>
                                        <label>Location</label>
                                        <select
                                            name="location_id"
                                            value={formData.location_id}
                                            onChange={handleChange}
                                            required
                                            disabled={loadingLocations}
                                            style={{width:"100%"}}
                                        >
                                            <option value="">
                                                {loadingLocations ? 'Loading locations...' : 'Select Location'}
                                            </option>
                                            {locations.map((loc) => (
                                                <option key={loc.id} value={loc.id}>
                                                    {loc.location_address || `Location ${loc.id}`}
                                                </option>
                                            ))}

                                        </select>
                                        {/* Debug info - remove in production */}
                                        {process.env.NODE_ENV === 'development' && locations.length > 0 && (
                                            <small style={{ color: '#666', fontSize: '12px' }}>
                                                Debug: {locations.length} locations loaded
                                            </small>
                                        )}
                                    </div>
                                </div>
                                
                            </div>
                            <h1 style={{fontSize: 20, marginTop: 40}}>Roles & Permissions</h1>
                {/* <div className='modal-footer' style={{ marginTop: 20 }} /> */}
                 <div
        style={{
          margin: "30px 0 10px 10px",
          display: "flex",
        //   justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span style={{ fontSize: 14, fontWeight: "bold",marginTop:0 }}>Select All</span>
        <ToggleSlider checked={selectAll} onChange={handleSelectAllChange} />
      </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                  {roleLoading ? (
                    <Spinner size='sm' animation="border" role="status" />
                  ) : (
                    roles.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          width: "90px",
                          minHeight: "62px",
                          padding: "5px",
                          margin: "5px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "5px",
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                          border: "1px solid rgba(0,0,0,0.12)",
                          boxSizing: "border-box",
                          overflow: "hidden",
                        }}
                      >
                        <p style={{ fontSize: 10, margin: 0, textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                        <ToggleSlider
                          checked={roleStates[item.name]}
                          onChange={() => handleRoleToggleChange(item.name)}
                        />
                      </div>
                    ))
                  )}
                </div>

                <div className={classes.modalFormFooter}>
                                    <button
                                        type="submit"
                                        className={classes.processModalBtn0}
                                        disabled={submitting || loadingLocations}
                                    >
                                        {submitting ? 'Adding...' : 'Add User'}
                                    </button>
                                </div>
                        </form>

                    </div>
                </div>
            )}
            {isPermisionOpenModal && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        <div className={classes.modalModalHeader}>
                            <h2>Add Permissions for {userPer?.name}</h2>
                            <button
                                className={classes.closeModalBtn}
                                onClick={() => setIsPermissionModalOpen(false)}
                            >
                                &times;
                            </button>
                        </div>

                        <form onSubmit={handleEditSubmit}>
                           
                            <h1 style={{fontSize: 20, marginTop: 40}}>Roles & Permissions</h1>
                {/* <div className='modal-footer' style={{ marginTop: 20 }} /> */}
                 <div
        style={{
          margin: "30px 0 10px 10px",
          display: "flex",
        //   justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span style={{ fontSize: 14, fontWeight: "bold",marginTop:0 }}>Select All</span>
        <ToggleSlider checked={selectAll} onChange={handleSelectEditChange} />
      </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                  {roleLoading ? (
                    <Spinner size='sm' animation="border" role="status" />
                  ) : (
                    roles.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          width: "90px",
                          minHeight: "62px",
                          padding: "5px",
                          margin: "5px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "5px",
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                          border: "1px solid rgba(0,0,0,0.12)",
                          boxSizing: "border-box",
                          overflow: "hidden",
                        }}
                      >
                        <p style={{ fontSize: 10, margin: 0, textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                        <ToggleSlider
                          checked={roleStates[item.id]}
                          onChange={() => handleRoleToggleChange(item.id)}
                        />
                      </div>
                    ))
                  )}
                </div>

                <div className={classes.modalFormFooter}>
                                    <button
                                        type="submit"
                                        className={classes.processModalBtn0}
                                        disabled={submitting || loadingLocations}
                                    >
                                        {submitting ? 'Updating...' : 'Update Permission'}
                                    </button>
                                </div>
                        </form>

                    </div>
                </div>
            )}

            {isNewModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        <div className={classes.modalModalHeader}>
                            <h2>Edit User</h2>
                            <button
                                className={classes.closeModalBtn}
                                onClick={() => setIsNewModalOpen(false)}
                            >
                                &times;
                            </button>
                        </div>
                   
                        <form onSubmit={handleUpdateSubmit}>
                            <div className={classes.modalModalBody}>
                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Name</label>
                                       {/* <input
                                        type="text"
                                        name="name"
                                        value={formData.name || selectedUser.name}
                                        onChange={handleChange}
                                        placeholder="Enter Name"
                                        /> */}
                                        <input
                                                type="text"
                                                name="name"
                                                value={editformData.name}
                                                onChange={handleEditChange}
                                                placeholder="Enter Name"
                                                />
                                    </div>
                                    <div className={classes.modalFormGroup}>
                                        <label>Phone Number</label>
                                        <input
                                            type="number"
                                            name="phone_no"
                                            value={editformData.phone_no}
                                            onChange={handleEditChange}
                                            placeholder="Enter Phone Number"
                                            />
                                    </div>
                                </div>

                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={editformData.email}
                                            onChange={handleChange}
                                            placeholder="Enter Email"
                                        />
                                    </div>
                                    <div className={classes.modalFormGroup}>
                                        <label>Location</label>
                                        <select
                                            name="location_id"
                                            value={editformData.location_id}
                                            onChange={handleChange}
                                            required
                                            disabled={loadingLocations}
                                            style={{width:"100%"}}
                                        >
                                            {/* <option value="">
                                                {loadingLocations ? 'Loading locations...' : 'Select Location'}
                                            </option>
                                            {locations.map((loc) => (
                                                <option key={loc.id} value={loc.id}>
                                                    {loc.location_address || `Location ${loc.id}`}
                                                </option> */}
                                                <option value="">Select Location</option>
                                                    {locations.map((loc) => (
                                                        <option key={loc.id} value={loc.id}>
                                                        {loc.location_address || `Location ${loc.id}`}
                                                        </option>
                                            ))}

                                        </select>
                                        {/* Debug info - remove in production */}
                                        {process.env.NODE_ENV === 'development' && locations.length > 0 && (
                                            <small style={{ color: '#666', fontSize: '12px' }}>
                                                Debug: {locations.length} locations loaded
                                            </small>
                                        )}
                                    </div>
                                </div>

                                
                                 <h1 style={{fontSize: 20, marginTop: 40}}>Roles & Permissions</h1>
                {/* <div className='modal-footer' style={{ marginTop: 20 }} /> */}
                 <div
        style={{
          margin: "30px 0 10px 10px",
          display: "flex",
        //   justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span style={{ fontSize: 14, fontWeight: "bold",marginTop:0 }}>Select All</span>
        <ToggleSlider checked={selectAll} onChange={handleSelectAllChange} />
      </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                  {roleLoading ? (
                    <Spinner size='sm' animation="border" role="status" />
                  ) : (
                    roles.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          width: "90px",
                          minHeight: "62px",
                          padding: "5px",
                          margin: "5px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "5px",
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                          border: "1px solid rgba(0,0,0,0.12)",
                          boxSizing: "border-box",
                          overflow: "hidden",
                        }}
                      >
                        <p style={{ fontSize: 10, margin: 0, textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                        {/* <ToggleSlider
                          checked={roleStates[item.name] || false}
                          onChange={() => handleRoleToggleChange(item.name)}
                        /> */}
                         <ToggleSlider
                             checked={roleStates[item.name]}
                                onChange={() => handleToggle(item.name)}
                            /> 
                      </div>
                    ))
                  )}
                </div>

                                <div className={classes.modalFormFooter}>
                                    <button className={classes.processModalBtn0}>
                                        Edit User
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isDeleteModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalDeleteContent}>
                        <div className={classes.modalModalHeader}>
                            <h2 style={{ marginBottom: "auto" }}>Delete User</h2>
                            <button
                                className={classes.closeModalBtn}
                                onClick={() => setIsDeleteModalOpen(false)}
                            >
                                &times;
                            </button>
                        </div>

                        <div className={classes.modalModalBodyText00}>
                            <p>
                                Are you sure you want to delete user:{" "}
                                    <strong>{userToDelete?.name}</strong>?
                            </p>
                            <div className={classes.modalFormDelFooter}>
                                <button
                                    className={classes.ModalDeleteBtn0}
                                >
                                    Delete User
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default ManageUser;